"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatDate = void 0;
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns props `value` formatted according to selected `format`.
 * The timezone information in the date value is optional. If the timezone information is missing, then it is expected to be the tenant timezone.
 * @see {@link useFormatDate} for more information.
 *
 * @see {@link FormatDateProps} for the available props and options.
 * @example
  // basic usage
  <FormatDate value={new Date()} type={DateFormat.ShortDateTime} />

  // use a custom pattern
  <FormatDate value={new Date()} type={DateFormat.Custom} options={{ customPattern: 'dd.MM.yyyy' }} />

  // enable transformation to the runtime (local) timezone
  <FormatDate value={new Date()} type={DateFormat.ShortDateTime} options={{ toLocalTimezone: true }} />
 */
const FormatDate = ({
  children,
  value,
  format,
  options
}) => {
  const formattedValue = (0, _hooks.useFormatDate)(value ?? children, format, options);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: formattedValue
  });
};
exports.FormatDate = FormatDate;
//# sourceMappingURL=FormatDate.js.map